import { render, staticRenderFns } from "./Stack2.vue?vue&type=template&id=64bc3c7b&scoped=true&"
import script from "./Stack2.vue?vue&type=script&lang=ts&"
export * from "./Stack2.vue?vue&type=script&lang=ts&"
import style0 from "./Stack2.vue?vue&type=style&index=0&id=64bc3c7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc3c7b",
  null
  
)

export default component.exports